<template>
	<section class="promotions background-light main-content align-center">
		<div class="row row-header align-center">
			<div class="pre-header-logo" />
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row promotions-row flex-row slide-row">
			<client-only>
				<nuxt-link
					v-for="promoblock in promoblocks.slice(0, 4)"
					:key="promoblock.ID"
					:to="localePath(`/${promoblock.link}`)"
					class="slick-item columns column3"
				>
					<picture>
						<source v-if="promoblock.imageWebp" :srcset="promoblock.imageWebp" type="image/webp" />
						<source :srcset="promoblock.image" />
						<img loading="lazy" :src="promoblock.image" :alt="promoblock.imageAlt" />
					</picture>
					<div class="slick-slide-content align-left">
						<h3>{{ promoblock.header }}</h3>
						<span>
							{{ promoblock.button }}
							<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
						</span>
					</div>
				</nuxt-link>
			</client-only>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	promoblocks: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.promotions {
	background: var(--primary-background-color);
}

.row-header {
	max-width: 980px;
}

.slick-item {
	img {
		opacity: 0.8;
		transition: opacity 0.3s ease-in-out;
	}

	&:hover {
		img {
			opacity: 1;
		}
	}
}
</style>
